module.exports = __webpack_public_path__ + "static/media/no_found-person.d99c823e.png";